<template>
  <div id="AlertBar">
    <transition-group appear name="slide-down">
      <Notice
        v-for="alert in alerts"
        :key="alert.text || 1"
        :class="alert.theme"
        :isClosable="true"
        @close="close(alert.text)">
        {{ alert.text }}
        <template v-if="alert.button">
          <Btn class="danger ib xs" :to="alert.button.route" @click="close(alert.text)">
            {{ alert.button.text }}
          </Btn>
        </template>
      </Notice>
    </transition-group>
  </div>
</template>

<script>
import { actions, getters } from 'views/utils'

export default {
  computed: getters('alerts'),
  methods: {
    close(text) {
      this.CLOSE_ALERT({ text })
    },
    ...actions('CLOSE_ALERT'),
  },
}
</script>

<style lang="scss">
#AlertBar {
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 85;

  .Notice {
    margin: 0;

    .Btn {
      line-height: 1.25rem;
      padding: 0 1rem;
    }
  }
}
</style>
